import React from 'react';

const Reports = () => (
    <div className="content-container">
        <h1>Reports</h1>
        <p>This is the Reports page.</p>
    </div>
);

export default Reports;
